// Карточка ролика. Играть — только официальным плеером: открываем YouTube (external_url), региональный запрет
// он применяет сам; плюс не показываем ролики, закрытые для региона зрителя (videoAllowed).
// Атрибуция канала обязательна (compliance.attribution_required).
// «Видеоблоки» выключены в Профиле (HQ-1059) — карточки нет; кроме экрана роликов (вкладка «Videos»): там always.
import { videoDelivery } from '../analytics/events';
import { currentScreen, track } from '../analytics/track';
import type { VideoItem } from '../api/types';
import { useEnergyEarn } from '../api/worldQueries';
import { t, type StringKey } from '../i18n/i18n';
import { timeAgo } from '../i18n/timeAgo';
import { useVideoBlocks } from '../settings/localSettings';
import { openExternal } from '../telegram/webapp';
import styles from './VideoCard.module.css';

const TYPE_LABEL: Record<string, StringKey> = {
  highlights: 'mc_video_type_highlights', extended_highlights: 'mc_video_type_extended_highlights', wickets: 'mc_video_type_wickets',
};

function duration(seconds: number | null | undefined): string | null {
  if (!seconds) return null;
  const m = Math.floor(seconds / 60);
  return `${m}:${String(seconds % 60).padStart(2, '0')}`;
}

export function VideoCard({ item, always }: { item: VideoItem; /** рисовать и при выключенных видеоблоках */ always?: boolean }) {
  const videoBlocks = useVideoBlocks();
  const type = item.video?.type ? TYPE_LABEL[item.video.type] : undefined;
  const time = duration(item.video?.duration_seconds);
  const earn = useEnergyEarn();
  // ролик идёт в YouTube — досмотра не видим; энергию сервер засчитывает за открытие (договорено 10.10)
  const play = () => {
    // video_play: source — экран, где нажали (highlights, news_hub, home…); тип — от сервера, иначе highlight
    track('video_play', { video_id: String(item.id), video_type: item.video?.type || 'highlight', delivery: videoDelivery(item.playback), source: currentScreen() });
    earn('highlight', item.id);
    openExternal(item.playback.external_url);
  };
  if (!videoBlocks && !always) return null;
  return (
    <div className={styles.card}>
      <button className={styles.thumbWrap} onClick={play} aria-label={t('mc_video_open_youtube')}>
        {item.image_url && <img className={styles.thumb} src={item.image_url} alt="" loading="lazy" />}
        <span className={styles.play} aria-hidden="true">▶</span>
        {time && <span className={`score ${styles.duration}`}>{time}</span>}
      </button>
      <div className={styles.title}>{item.title}</div>
      <div className={styles.meta}>
        {item.source.channel_url
          ? <button className={styles.channel} onClick={() => openExternal(item.source.channel_url!)}>{item.source.channel_name}</button>
          : <span>{item.source.channel_name}</span>}
        {' · '}{type ? `${t(type)} · ` : ''}<span className={styles.time}>{timeAgo(item.published_at)}</span>
      </div>
    </div>
  );
}
